import { containsHostname } from './urls'

export const getFilteredLenders = ({ lenders, partnerPageUrl }) => {
  if (!lenders) {
    return []
  }

  if (!partnerPageUrl) {
    return lenders
  }

  const widgetOnCredibleDomain = containsHostname('credible.com', partnerPageUrl)

  if (widgetOnCredibleDomain) {
    return lenders
  }

  return lenders.filter(({ slug }) => slug !== 'citi')
}
